export default __webpack_public_path__ + "static/media/bg-ecosystems.a4439d17.jpg";